module.exports = __webpack_public_path__ + "static/media/Logo.0e86a78a.png";